import React from 'react'
import UniquePassAuthLogoutContainer from '../containers/UniquePassAuth/UniquePassAuthLogout.container'

/**
 * The UniquePassAuthLogout's page.
 */
const UniquePassAuthLogout = () => <UniquePassAuthLogoutContainer />

export default UniquePassAuthLogout
